<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Ventas</h1>
          <p class="view-header__subtitle">Gestioná facturas, notas de crédito y notas de débito.</p>
        </div>
        <div class="view-header__actions">
          <router-link :to="nuevaVentaLink" class="btn view-header__btn view-header__btn--primary">
            <i class="bi bi-plus-lg"></i>
            Nueva venta
          </router-link>
          <div class="btn-group">
            <button
              type="button"
              class="btn view-header__btn dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Más
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <router-link :to="nuevaNotaDeCreditoLink" class="dropdown-item">Nueva nota de crédito</router-link>
              </li>
              <li>
                <router-link :to="nuevaNotaDeDebitoLink" class="dropdown-item">Nueva nota de débito</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="filters.qclient" type="search" class="form-control" placeholder="Buscar por cliente">
          </div>
          <div class="filters-panel__field">
            <input v-model="filters.qname" type="search" class="form-control" placeholder="Buscar por producto">
          </div>
          <div class="filters-panel__field">
            <q-select v-model="selectedTypeFilter" :options="typeFilterOptions" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange ref="daterange" :opendir="'left'" :initial-start="dateRangeStart" :initial-end="dateRangeEnd" @datepicked="onDatePicked" />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn filters-panel__btn--outline" @click="clearFilters">
              <i class="bi bi-eraser"></i>
              Limpiar filtros
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @saleDetail="getSaleDetail"
        @getPDF="downloadPDF"
        @cancel="cancelOrDeleteSale"
        @createCreditNote="createCreditNote"
        @createDebitNote="createDebitNote"
        @updateSale="updateSale"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import { mapState } from 'vuex';
import Daterange from "../../global/Daterange-component.vue";
import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";
import myaxios from 'axios';
import QSelect from '@/components/shared/QSelect.vue';


export default {
  components: {
    VdtnetTable,
    Daterange,
    QSelect,
  },
  mixins: [formatDateMixin,formatMoneyMixin],
  data: function () {
    const defaultRange = this.last30DaysRange();
    return {
      filters: {
        qname: '',
        qclient: ''
      },
      selectedTypeFilter: 'all',
      searchDelay: null,
      isLoading: false,
      dateRangeStart: defaultRange.startDate,
      dateRangeEnd: defaultRange.endDate,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL+"/api/sales/list",
          type: "GET",
          data: (d) => {
            d.filter = this.selectedTypeFilter;
            d.filters = this.filters;
            d.branchoffice_id = this.branchofficeId;
            d.daterange = this.daterange;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: null,
        destroy: true,
        ordering: true,
        order: [[3, "desc"]],
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false
      },
      fields: {
        id: { visible: false },
        tipo: { label: "Tipo", searchable: true, width: "70px" },
        number: { label: "N°", searchable: true, width: "70px" },
        created_at: {
          label: "Fecha",
          searchable: true,
          width: "130px",
          render: (data) => this.formatoFechaHora(data),
        },
        client: {
          label: "Cliente",
          searchable: true,
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        user: { label: "Vendedor", searchable: true, width: "120px" },
        branchoffice: { label: "Sucursal", visible: false },
        status: {
          label: "Estado",
          width: "110px",
          render: (data, type) => {
            if (type !== 'display') return data;
            if (data === "FACTURADA") return '<span class="status-badge status-badge--success">Facturada</span>';
            if (data === "ANULADA") return '<span class="status-badge status-badge--danger">Anulada</span>';
            return '<span class="status-badge status-badge--neutral">Desconocido</span>';
          }
        },
        total: {
          label: "Total",
          searchable: true,
          width: "110px",
          align: "right",
          render: (data, type) => {
            const formatted = this.formatoDinamicoMoneda(data, type);
            return type === 'display' ? `<span class="data-table__primary">${formatted}</span>` : formatted;
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "180px",
          align: "right",
          render: (data) => {
            const isInvoiced = data === "FACTURADA";
            const isCanceled = data === "ANULADA";
            if (!isInvoiced && !isCanceled) return '';

            const baseButtons = `
              <button data-action="saleDetail" class="table-action-btn" type="button" title="Ver detalle">
                <i class="bi bi-file-earmark-text"></i>
              </button>
              <button data-action="getPDF" class="table-action-btn" type="button" title="Descargar PDF">
                <i class="bi bi-filetype-pdf"></i>
              </button>
              <button data-action="createCreditNote" class="table-action-btn" type="button" title="Crear nota de crédito">NC</button>
              <button data-action="createDebitNote" class="table-action-btn" type="button" title="Crear nota de débito">ND</button>
            `;

            const cancelButton = isInvoiced
              ? `<button data-action="cancel" class="table-action-btn" type="button" title="Anular/Eliminar comprobante">
                  <i class="bi bi-trash"></i>
                </button>`
              : '';

            return `<div class="table-action-group">${baseButtons}${cancelButton}</div>`;
          }
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  watch: {
    'filters.qclient'() {
      this.debouncedReload();
    },
    'filters.qname'() {
      this.debouncedReload();
    },
    selectedTypeFilter() {
      this.refreshTable();
    },
    branchofficeId() {
      this.refreshTable();
    },
    daterange() {
      this.refreshTable();
    },
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    onDatePicked(date) {
      this.dateRangeStart = date.startDate;
      this.dateRangeEnd = date.endDate;
    },
    clearFilters() {
      this.filters.qclient = '';
      this.filters.qname = '';
      this.selectedTypeFilter = 'all';
      const defaultRange = this.last30DaysRange();
      this.dateRangeStart = defaultRange.startDate;
      this.dateRangeEnd = defaultRange.endDate;
    },
    debouncedReload() {
      if (this.searchDelay) clearTimeout(this.searchDelay);
      this.searchDelay = setTimeout(() => this.refreshTable(), 700);
    },
    getSaleDetail(data) {
      window.open(
        this.$router.resolve({
          name: "Detalle de venta",
          params: { saleId: data.id },
        }).href,
        '_blank'
      );
    },
    createCreditNote(data) {
      this.$router.push({ name: 'Nueva NC desde venta', params: { saleId: data.id } });
    },
    createDebitNote(data) {
      this.$router.push({ name: 'Nueva ND desde venta', params: { saleId: data.id } });
    },
    updateSale(data) {
      localStorage.removeItem('header');
      localStorage.removeItem('products');
      this.$router.push({ name: 'Editar venta', params: { saleId: data.id } });
    },
    cancelOrDeleteSale(data) {
      if (data.letter !== 'P') {
        alert('No se puede eliminar factura electronica');
        return;
      }
      const isInvoiced = data.status === "FACTURADA";
      const url = isInvoiced ? "/api/sales/cancel" : "/api/sales/delete";
      const message = isInvoiced
        ? "¿Está seguro que desea cancelar este comprobante?"
        : "¿Está seguro que desea borrar este comprobante?";
      if (!confirm(message)) return;
      this.$http.post(url, { id: data.id }).then((response) => {
        if (response.data.code === 201) this.refreshTable();
      });
    },
    downloadPDF(data) {
      this.$http.get('/api/configs/branchoffice/getData').then(response => {
        const branchoffice = response.data.data.branchoffices.find(bo => bo.id === data.bo_id);
        const printTicket = branchoffice.options.print_bill_ticket === 1 ? 1 : 0;
        const uninterceptedAxiosInstance = myaxios.create();

        if (printTicket === 0) {
          const filename = data.client + data.updated_at + '.pdf';
          this.$http.get("/api/sales/getURL/" + data.id).then((res) => {
            uninterceptedAxiosInstance.get(res.data, { responseType: 'blob' }).then((blobRes) => {
              const blob = new Blob([blobRes.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
              URL.revokeObjectURL(link.href);
            });
          });
        } else {
          this.$http.get('/api/sales/reprintSale/' + data.id).then(res => {
            uninterceptedAxiosInstance.get(res.data.data.urlInvoice, { responseType: 'blob' }).then((blobRes) => {
              const blob = new Blob([blobRes.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              const formattedDate = new Date().toLocaleDateString().replace(/\//g, '-');
              link.href = URL.createObjectURL(blob);
              link.download = 'Reimpresion_' + formattedDate + '.pdf';
              link.click();
              URL.revokeObjectURL(link.href);
            });
          });
        }
      });
    },
  },
  computed: {
    daterange() {
      if (!this.dateRangeStart || !this.dateRangeEnd) return null;
      return `${this.formatoFecha2Daterange(this.dateRangeStart)} - ${this.formatoFecha2Daterange(this.dateRangeEnd)}`;
    },
    typeFilterOptions() {
      return [
        { value: 'all', label: 'Todos los comprobantes' },
        { value: 'invoices', label: 'Facturas' },
        { value: 'credit-notes', label: 'Notas de crédito' },
        { value: 'debit-notes', label: 'Notas de débito' },
        { value: 'other', label: 'Otros comprobantes' },
        { value: 'deleted', label: 'Comprobantes anulados' },
      ];
    },
    nuevaVentaLink() {
      localStorage.removeItem('header');
      localStorage.removeItem('products');
      return { name: "Nueva venta" };
    },
    nuevaNotaDeCreditoLink() {
      return { name: "Nueva nota de credito" };
    },
    nuevaNotaDeDebitoLink() {
      return { name: "Nueva nota de debito" };
    },
    ...mapState('branchoffices', {
      branchofficeId: state => state.selectedBranchofficeId,
    }),
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
